import InputSearch from "./inputSearch";

export default InputSearch;
